import { FormHelperText, InputLabel, Stack, TextField, Typography } from "@mui/material";
import React from "react";
import { ErrorMessage, Form, Formik } from "formik";
import TrackingValidation from "./TrackingValidation";

const TrackingTextField = ({ setTrackingValue }) => {
  const initialValues = {
    trackingCode: "",
  };

  return (
    <>
      <Stack width="100%">
        <Formik
          initialValues={initialValues}
          onSubmit={"handleSubmit"}
          validationSchema={TrackingValidation}
          enableReinitialize={true}
          validateOnMount={true}
          initialTouched={{
            trackingCode: true,
          }}
        >
          {({ values, handleChange, isValid, errors, touched, setFieldValue }) => (
            <Form>
              <Stack width="100%" spacing={0.5} textAlign="left">
                <InputLabel>کد رهگیری محصول</InputLabel>
                <TextField
                  name="trackingCode"
                  onChange={(e) => {
                    setFieldValue("trackingCode", e.target.value);
                    setFieldValue("itemName", e.target.value);
                    handleChange(e);
                    setTrackingValue(e.target.value);
                  }}
                  placeholder="کد رهگیری محصول مورد نظر را وارد کنید."
                />
                <ErrorMessage name="trackingCode" component={Typography} color="error.main" variant="caption" />

                <FormHelperText
                  name="trackingCode"
                  component={Typography}
                  sx={{ color: "warning.main" }}
                  variant="caption"
                >
                  کد رهگیری با فرمت معتبر و با رعایت حروف کوچک و بزرگ باید وارد شود.
                  <Typography component="span" variant="caption" sx={{ display: "flex" }}>
                    نمونه: AVC-10-Ha-1256-1234-2244-3665-9918-1022
                  </Typography>
                </FormHelperText>
              </Stack>
            </Form>
          )}
        </Formik>
      </Stack>

      {/* <LoadingScreen open={loadingProfile || loading} title="لطفا منتظر بمانید ..." /> */}
    </>
  );
};

export default TrackingTextField;
